<template>
    <!-- 轮播图广告组件 -->
    <div class="bannerModule" :class="{roundBorder8 : isRoundBorder}" style="overflow: hidden"
         v-show="adList.length > 0 || isShowBanner">

        <div class="shadow646464">
            <!-- 配置slider组件 -->
            <slider class="" ref="slider" :options="sliderOptions" @slide='slide' @tap='onTap' @init='onInit'>
                <!-- 直接使用slideritem slot -->
                <slideritem v-for="(item,index) in adList" :key="index">
                    <img class="fullSpace cover" :src="item.img" :title="item.title" @click="clickAd(item)" />
                </slideritem>
                <!-- 设置loading,可自定义 -->
                <div slot="loading">loading...</div>
            </slider>
        </div>

        <div class="pagination">
            <span class="item" :class="{active : index === sliderActiveIndex}"
                  v-for="(item, index) in adList" :key="index"></span>
        </div>
    </div>
</template>

<script>
// modules
import { slider, slideritem } from 'vue-concise-slider'// import slider components

// part
import adModulePart     from '@comp/ad/adModulePart';

// config
import appConfig from '@/appConfig';

// util
import appHelper        from "@util/appHelper";
import dataMixedUtils   from "@util/dataMixedUtils";

const config = {
    apiConfig : {
        list : {
            url : "portal/advertis/getAdvertisByType",
            dataPath : 'data'
        }
    }
};

export default {
    name: "bannerModule2",
    extends : adModulePart,
    components: {
        slider,
        slideritem
    },
    props:{
        isShowBanner:{
            type:Boolean,
            default:true,
        },
        isRoundBorder : {
            type:Boolean,
            default:true,
        }
    },
    data() {
        return {
            apiConfig : config.apiConfig,
            sliderOptions: {
                currentPage: 0,
                // thresholdDistance:500,
                // thresholdTime:100,
                autoplay:3000,
                loop:true,
                direction:'horizontal',
                loopedSlides:1,
                slidesToScroll:1,
                timingFunction: 'ease',
                speed: 500,
                pagination : false
            },
            sliderActiveIndex : 1
        }
    },
    methods : {
        // Listener event
        slide (data) {
            this.sliderActiveIndex = data.currentPage
        },
        onTap (data) {
        },
        onInit (data) {
            this.sliderActiveIndex = data.currentPage
        },
    },
    mounted() {

        // demo data
        if (appConfig.mode == 'demo')
        {
            this.adList = dataMixedUtils.array.buildDataList(3, (index) => {
                return {
                    id : index,
                    image : appHelper.getRandomCoverImage(),
                    link : 'javascript:;'
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.bannerModule {

    .bannerItem {
        overflow: hidden;
    }

    .pagination {
        text-align: center;
        .item {
            display: inline-block;
            width: 6px;
            height: 6px;
            background: #D3D3D3;
            border-radius: 3px;
            margin-right: 4px;

            &.active {
                width: 16px;
                background: #B7B7B7;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }
}

</style>
